export const PAGINTAION_DEFAULT_PAGE = 1;
export const MAX_VISIBLE_PAGES = 8;

export const PAGINATION_LABEL_FALLBACKS = {
  tooltipGoToLast: "Go to last page",
  tooltipNext: "Next",
  tooltipPrevious: "Previous",
  tooltipGoToFirst: "Go to first page",
  totalLabel: "Total",
  goToLabel: "Go To",
  pageSizeLabel: "Page",
};
